export const ADD_CONVERSATION_TO_BATCH_GROUP = 'ADD_CONVERSATION_TO_BATCH_GROUP';
export const REMOVE_CONVERSATION_FROM_BATCH_GROUP = 'REMOVE_CONVERSATION_FROM_BATCH_GROUP';
export const CLEAR_THREAD_LIST_BATCH_GROUP = 'CLEAR_THREAD_LIST_BATCH_GROUP';
export const ADD_ALL_CONVERSATIONS_TO_BATCH_GROUP = 'ADD_ALL_CONVERSATIONS_TO_BATCH_GROUP';
export const SET_REALTIME_SORT_ORDER = 'SET_REALTIME_SORT_ORDER';
export const SET_STATUS_TOGGLE = 'SET_STATUS_TOGGLE';